import React from 'react';
import { array, func, shape, string } from 'prop-types';

import CSS from './styles.scss';

import InteractiveCircle from 'Shared/InteractiveCircle';


const AffordancesViews = ({ markers, openNoteEditor, removeNote, selectedHighlight }) => {
  return (
    <div className={ CSS['container'] }>
      <div
        className={ `${CSS['item']} ${CSS['edit-note']}` }
        onClick={ openNoteEditor }>Edit Note
      </div>
      <div className={ `${CSS['item']} ${CSS['change-highlight']}` }>
        <span className={ CSS['text'] }>Change Highlight</span>
        <div className={ CSS['radio-list'] }>
          {
            markers.map((marker, key) => {
              return (
                <InteractiveCircle key={ key }
                  className={ CSS['radio-item'] }
                  marker={ marker }
                  outerRingFill="#000000"
                  xFill="#FFFFFF"
                  selectedHighlight={ selectedHighlight }
                  type="menu"
                  centerRadius="10" />
              );
            })
          }
        </div>
      </div>
      <div
        className={ `${CSS['item']} ${CSS['delete']}` }
        onClick={ removeNote }>Delete</div>
    </div>
  );
};

AffordancesViews.propTypes = {
  markers: array,
  openNoteEditor: func,
  removeNote: func,
  selectedHighlight: shape({
    color: string.isRequired,
    label: string.isRequired,
    markerId: string.isRequired,
    id: string,
    noteText: string,
    lastModifiedAt: string
  })
};


export default AffordancesViews;
